export class editColumnEventDetails {
    function? : string;
    columnIndex?: number;
    data : any;
}
